import { exactColourTerms, canonicalSearchURL } from './fivepoint-search-query.js';

// A compact search form with local recent terms; results load only after submission.
(() => {
  const destination = canonicalSearchURL(location.href);
  if (destination.href !== location.href) { location.replace(destination.href); return; }
  const recentKey = 'fivepoint:recent-searches:v1';
  function connect(root = document) {
    root.querySelectorAll('[data-fp-search]:not([data-search-connected])').forEach(form => {
      form.dataset.searchConnected = 'true';
      const header = form.closest('[data-fp-header]');
      const input = form.querySelector('[name="q"]');
      const panel = document.getElementById(input.getAttribute('aria-controls'));
      const triggers = [...header.querySelectorAll('[data-fp-search-open]')];
      const lifecycle = new AbortController();
      const listen = (target, event, callback) => target.addEventListener(event, callback, { signal: lifecycle.signal });
      const text = (key, legacy) => form.dataset[key] || legacy;
      let restoringFocus = false;
      const searchURL = query => {
        const url = new URL(form.action);
        url.searchParams.set('q', query);
        url.searchParams.set('type', 'product');
        return canonicalSearchURL(url);
      };
      const readRecent = () => {
        const entries = JSON.parse(localStorage.getItem(recentKey) || '[]');
        if (!Array.isArray(entries) || entries.some(term => typeof term !== 'string')) throw new Error(window.FivePointI18n.t("Invalid recent searches"));
        return entries.filter(term => term.trim() && term.length <= 120).slice(0, 5);
      };
      const renderRecent = () => {
        const group = panel.querySelector('[data-fp-recent-searches]');
        const list = group.querySelector('[data-fp-recent-list]');
        list.replaceChildren();
        try {
          const terms = readRecent();
          group.hidden = !terms.length;
          terms.forEach(term => {
            const link = document.createElement('a');
            link.href = searchURL(term); link.textContent = term;
            list.append(link);
          });
        } catch (error) {
          group.hidden = false;
          const message = document.createElement('p');
          message.textContent = text('recentUnavailable', window.FivePointI18n.t("Recent searches are unavailable in this browser."));
          list.append(message);
        }
      };
      const open = () => {
        if (restoringFocus) return;
        panel.hidden = false;
        header.classList.add('fp-search-open');
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'true'));
        header.querySelectorAll('.fp-mega-trigger[aria-expanded="true"],.fp-desktop-menu[aria-expanded="true"]').forEach(trigger => {
          document.getElementById(trigger.getAttribute('aria-controls')).hidden = true;
          trigger.setAttribute('aria-expanded', 'false');
        });
        renderRecent();
      };
      const close = (focus = false) => {
        panel.hidden = true;
        header.classList.remove('fp-search-open');
        triggers.forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        if (focus) {
          restoringFocus = true; (triggers[0] || input).focus(); restoringFocus = false;
        }
      };
      triggers.forEach(trigger => listen(trigger, 'click', () => {
        if (!panel.hidden) { close(true); return; }
        open(); input.focus();
      }));
      listen(input, 'focus', open);
      listen(input, 'click', open);
      listen(input, 'input', open);
      listen(input, 'keydown', event => {
        if (event.key === 'ArrowDown') {
          event.preventDefault(); open(); panel.querySelector('a')?.focus();
        }
      });
      listen(header, 'keydown', event => {
        if (event.key === 'Escape' && !panel.hidden) { event.preventDefault(); close(true); }
      });
      listen(panel.querySelector('[data-fp-search-close]'), 'click', () => close(true));
      const inside = target => form.contains(target) || panel.contains(target) || triggers.some(trigger => trigger.contains(target));
      listen(document, 'pointerdown', event => { if (!inside(event.target)) close(); });
      listen(document, 'focusin', event => { if (!inside(event.target)) close(); });
      listen(form, 'submit', () => {
        const query = input.value.trim();
        if (!query) { form.action = searchURL(''); return; }
        window.FivePointEvents?.emit('fp_search_submit', {query_length: query.length}, {source_surface:'header',component_id:'header-search'});
        try { localStorage.setItem(recentKey, JSON.stringify([query, ...readRecent().filter(term => term !== query)].slice(0, 5))); }
        catch (error) { console.error('FivePoint recent searches could not be saved:', error); }
      });
      listen(form, 'formdata', event => {
        const query = String(event.formData.get('q') || '').trim();
        if (query) event.formData.set('q', exactColourTerms(query));
        else { event.formData.delete('q'); event.formData.delete('type'); }
      });
      header.querySelectorAll('.fp-country').forEach(country => {
        listen(document, 'pointerdown', event => { if (!country.contains(event.target)) country.open = false; });
        listen(country, 'keydown', event => { if (event.key === 'Escape') { country.open = false; country.querySelector('summary').focus(); } });
      });
      listen(document, 'shopify:section:unload', event => {
        if (!event.target.contains(form)) return;
        lifecycle.abort();
        delete form.dataset.searchConnected;
      });
    });
  }
  document.addEventListener('shopify:section:load', event => connect(event.target));
  connect();
})();
